import { render, staticRenderFns } from "./OrderDetailSource.vue?vue&type=template&id=770e39c6"
import script from "./OrderDetailSource.vue?vue&type=script&lang=js"
export * from "./OrderDetailSource.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailSource.vue?vue&type=style&index=0&id=770e39c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports